export default __webpack_public_path__ + "static/media/2430.42f33624.png";